import type { IconSvgObject } from './types';

const EnergyEllipseIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.00009 12.4999L13 5.99991V11.4999H16L11 17.9999V12.4999H8.00009Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default EnergyEllipseIcon;
